<template>
  <div>
    <Breadcrumb :title="'Custom Footnote Valuation Upload'"></Breadcrumb>
    <div class="row no-gutters">
      <div class="col">
        <button class="btn btn-primary" style="float:right;" @click.prevent='downloadTemplate'><span class="fa fa-download"></span> Download Template</button>
        <button class="btn btn-secondary" style="float:right;margin-right:10px;" @click.prevent='backtoCustomFootnote'>
          <span class="k-icon k-i-undo" >  </span> &nbsp;Back to Custom Footnote
        </button>

      </div>
    </div>
    <div class="row">
      <br>
    </div>
    <BaseAuditDropzone ref="ParentFileUploaded" :id="'CustomFootnote'" :acceptedFileTypes="SheetJSFT" @change="_change" @Remove="ClearForm" :File="inputfile" :UploadType="FileUploadType"></BaseAuditDropzone>
    <br><br>
    <div ref="refCustomerror"
         id="Customerror"
         class="alert alert-danger"
         role="alert"
         v-show="pageErrors.length"
    >
      <span v-show="pageErrors.length" class="alert-danger">
        <b>Please correct the following error(s):</b>
        <ul>
          <li v-for="error in pageErrors" :key="error">{{ error }}</li>
        </ul>
      </span>
    </div>
    <div v-show="displayPage">
      <div class="row no-gutters">
        <div class="col">
          <div class="form-row">
            <div class="col-md-12">
              <BaseGrid :mode="'editform'" :config="BaseModelFootnoteConfig" :data="dataFootnoteExcel" @DeleteItem="DeleteDIfromGrid">
                <!-- @EditItem="EditPartner"  -->
              </BaseGrid>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <br>

      </div>
      <div class="row no-gutters" style='float: right;margin-left:15px;'>
        <button type="button" id="btnSave" class="btn btn-primary" :disabled="(!isValid|| pageErrors.length>0 || dataFootnoteExcel.length<=0)" @click.prevent="SaveCustomFootnote">Save</button>

      </div>
      <div class="row no-gutters" style='float: right;'>
        <button type="button" id="btnSave" class="btn btn-secondary" @click.prevent="validateFn">Validate</button>
      </div>
      <div class="row">
        <br><br>

      </div>
    </div>

  </div>
</template>

<script>
import apiUtil from "@/services/apiUtil.js";
import sheetJSConfig from "@/configs/sheetJS.js";
import XLSX from "xlsx";
import funcUtil from "@/services/funcUtil.js";
import customAxios from "@/services/customAxios.js";
import { getUrl } from "../../configs/assets.js";
import { getFileName } from "../../configs/assets.js";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import BaseDropzone from "@/components/base/BaseDropzone.vue";
import BaseAuditDropzone from "@/components/base/BaseAuditDropzone.vue";
import moment from "moment";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import BaseInvestment from '@/models/BaseModelInvestment.js';
import BasePartner from '@/models/BaseModelPartner.js';
import BaseAllocation from '@/models/BaseModelDirectInvestmentValuation.js';
import { isNullOrUndefined } from "util";

import {
    mapActions,
    mapState,
    mapGetters
} from 'vuex';
import BaseModelFootnoteConfig from "./FootnoteUploadConfig.js";
import BaseModelDirectInvestmentValuation from '@/models/BaseModelDirectInvestmentValuation.js'
import DocumentManagerMixin from "@/mixins/DocumentManagerMixin.js";
import DropZoneGridConfig from "@/models/BaseModelDropZoneGrid.js";
import bulkUploadAuditConfig from "@/models/BaseModelAuditUploadDocument.js";

export default {
    components: {
        BaseGrid,
        Breadcrumb,
        BaseAuditDropzone,
    },
    mixins: [apiUtil, funcUtil,DocumentManagerMixin],
    data() {
        return {
            data: "",
            inputfile: {
                UploadFile: {}
            },
            //UploadFile:excelfile,
            displayPage: false,
            FileUploadType: {
                AllowMultiple: "false"
            },
            SheetJSFT: sheetJSConfig.fileType,
            BaseModelFootnoteConfig: BaseModelFootnoteConfig,
            dataFootnoteExcel: [],
            pageErrors: [],
            PartnerAPIData: [],
            InvestmentAPIData: [],
            isValid:false,
            bulkUploadAuditConfig: bulkUploadAuditConfig
        };
    },
    computed: {
        ...mapState("postModule", ["response"]),
        ...mapGetters("getModule", ["getAllItemFilter","withFilter"]),
    },
    methods: {
        ...mapActions("postModule", ["CreateAllItems","PostAllFilesAndUpdateMetadata","PostAllAuditFilesAndUpdateMetadata"]),
        _suppress(evt) {
            evt.stopPropagation();
            evt.preventDefault();
        },
        downloadTemplate() {
            let token = localStorage.getItem("eum")
           let tokenstr = `Bearer ${token}`
           let templateUrl = getUrl("CustomFootnoteExcel");
           let templateFileName = getFileName("CustomFootnoteExcel");
            
           this.$http({
              url: templateUrl,
              method: 'GET',
              headers: {
                'Authorization': tokenstr
              },
              responseType: 'blob', // important,
            }).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', decodeURIComponent(templateFileName));
         document.body.appendChild(link);
              link.click();
            });

        },

        _drop(evt) {
            evt.stopPropagation();
            evt.preventDefault();
            const files = evt.BaseModelTransfer.files;
            if (files && files[0]) this._file(files[0]);
        },
        _change(evt) {
            const files = this.inputfile.UploadFile[0];
            if (files) this._file(files);
        },
        _export(evt) {
            /* convert state to workbook */
            const ws = XLSX.utils.aoa_to_sheet(this.data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
            /* generate file and send to client */
            XLSX.writeFile(wb, "sheetjs.xlsx");
        },
        backtoCustomFootnote: function() {
      this.$router.push("/valuation/footnote");
        },
        _file(file) {
            /* Boilerplate to set up FileReader */
            try {
                const XLSX = require("xlsx");
                const reader = new FileReader();
                reader.onload = e => {
                    /* Parse data */
                    //const bstr = e.target.result;
                    let binary = "";
                    let bytes = new Uint8Array(e.target.result);
                    let length = bytes.byteLength;

                    for (let i = 0; i < length; i++) 
                    {
                        binary += String.fromCharCode(bytes[i]);
                    }
                    const bstr = binary
                    
                    const wb = XLSX.read(bstr, {
                        type: "binary"
                    });
                    /* Get Partner  data */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    const data = XLSX.utils.sheet_to_json(ws, {
                        range: sheetJSConfig.template.header - 1, 
                        header: 1
                    });
                    data.splice(0, 1);
                    if (data && data.length) {
                        
                        const result = this.withFilter(BaseModelFootnoteConfig.list, "");
                        let FootnoteID = (result.length <= 0) ? 700001 : this._getIncrementalID(result, "FootnoteID");
                        FootnoteID=FootnoteID-1;
                        for (var i = 0; i < data.length; i++) {
                            var FootnoteExcelObj = {};
                            FootnoteExcelObj.FootnoteID  = FootnoteID + 1;
                            FootnoteExcelObj.Footnote = data[i][0];                          
                            this.dataFootnoteExcel.push(FootnoteExcelObj);
                            FootnoteID = FootnoteExcelObj.FootnoteID;
                        }
                        this.displayPage = true;
                        
                        var grid = $("#FootnoteGrid").data("kendoGrid");

                        grid.dataSource.data(this.dataFootnoteExcel);
                    }else{
                        this._AlertPopup("Template is Empty","error").then((result) => {
                        })
                    }

                    /* Update state */
                    //this.data = data;
                    //console.log(JSON.stringify(data));
                };
                reader.readAsArrayBuffer(file);
            } catch (ex) {
                console.log(ex);
                //this.$Progress.fail();
            }
        },

        DeleteDIfromGrid: function (e) {
            //e.preventDefault();
            //alert("Delete button clicked from BaseGrid..");
            const message = "Are you sure you want to delete this record?";
             this._ConfirmationPopup(message,"DELETE").then((result) => {
             if (result.value) {
                var gview = window.$("#FootnoteGrid").data("kendoGrid");
                var dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));
                //var dataItem = JSON.stringify(window.$(e.currentTarget).closest("tr"));
                //alert(JSON.stringify(dataItem));
                let objIndex = this.dataFootnoteExcel.findIndex(
                    obj => obj.FootnoteID == dataItem.FootnoteID
                );
                this.dataFootnoteExcel.splice(objIndex, 1);
                var grid = $("#FootnoteGrid").data("kendoGrid");
                grid.dataSource.data(this.dataFootnoteExcel);
            }
             })
        },
        

        SaveCustomFootnote: function () {
            const self = this;
            let createObject = {
                Footnote: {
                    config: BaseModelFootnoteConfig,
                    createData: this.dataFootnoteExcel.slice()
                }
            };
            //this._createAllItems(NewPartnerobject).then(addnewpartner => {
            //let loader = this.$loading.show();
             self._APICrudPopup("APICrudpopup");
            this.CreateAllItems(createObject).then(result => {
                console.log(result);
                //self._AlertPopup("Footnote data saved successfully", "success");
            /** AUDIT DOCUMENT UPLOAD **/
            let FileUpload = [];
            let senderObj = {};
            //senderObj.Id = this.count++;
            let realfileName = this.inputfile.UploadFile[0].name;
         // senderObj.File = self._appendDatewithExcelName(fileName);
            senderObj.File = this.inputfile.UploadFile[0].upload.uuid
            senderObj.RealFileName = realfileName;
            senderObj.FileContent = this.inputfile.UploadFile[0];
            FileUpload.push(senderObj);
            this.UploadBulkAditFilesToDB(FileUpload)
                .then(response => {
                self._AlertPopup("Footnote data saved successfully", "success");
                })
                .catch(error => {
                self._AlertPopup("Some Error Occurred!", "info");
                })
                .finally(() => {
                //loader.hide();
                });
            /** AUDIT DOCUMENT UPLOAD END */
                this.$refs.ParentFileUploaded.$refs.FileUploaded.removeAllFiles();
            }).catch(error=>{
                self._AlertPopup("Some Error Occurred!","info");
            }).finally(()=>{
                //loader.hide();
            })
        },
        ClearForm() {    
            this.dataFootnoteExcel=[]  
            this.displayPage = false;
            this.pageErrors=[];
            this.isValid=false;
        },
        validateFn(e){
            let self = this;
            e.preventDefault();
            let dataItem = $("#FootnoteGrid").data("kendoGrid").dataSource.data();
            self.pageErrors=[];
            let errorMessages = new Set();
            
            self.isValid = true;
             
            dataItem.forEach((ele,i) => {
                self.Columns = [];
                if( ele.Footnote =="" || isNullOrUndefined(ele.Footnote)){
                    self.Columns.push({"column":"Footnote","row":i});
                     errorMessages.add("Footnote is required")
                }
                
                self.Columns.push({"column":"Validation","row":i});

                if(self.Columns.length != 1 && self.isValid){
                    self.isValid = false;
                }

                self.ValidateImportData('FootnoteGrid',self.Columns);

            })
            self.pageErrors=[...errorMessages]
        },

    },

    mounted() {
    }
}
</script>

